module.exports = __webpack_public_path__ + "static/media/BRB_sm1.1fef597d.png";